<template>
  <div class="layer">
      <!-- 认领成果 -->
    <el-row :gutter="20" class="width">
      <el-col :span="20" :offset="2" style="min-height: 90vh;">
        <div class="research">
          <div class="title">
            <span>认领后，您可以：①方便管理自己的科研成果 生成可视化的科研图谱，提升影响力 个人专属二维码，链接个人详情 及时了解从事领域的最新进展</span>
          </div>
          <div class="folding">
            <el-collapse accordion v-model="type" @change="changeType">
              <el-collapse-item
                v-for="(item,index) in collapseList"
                :key="index"
                :title="item.title"
                :name="index"
              >
                <collapse
                  :tableData="item.data"
                  :code="item.code"
                  v-loading="loading"
                  :subjectList="subjectList"
                  @saveData="saveData"
                  @screenData="getScreen"
                ></collapse>
              </el-collapse-item>
            </el-collapse>
            <el-button type="primary" class="finish" @click="finish" :loading="loading">{{loading?'完成中':'完成'}}</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="选择论文学科" class="dialog" :visible.sync="dialogFormVisibleAut">
      <div class="dialog_autView" >
        <div class="autInfo">
        <span>学科：</span>
        <el-tag
          v-loading='loading1'
          v-for="(item,index) in subjectList"
          :key="index"
          style="cursor: pointer;"
          :effect="item.choose?'dark':'plain'"
          :closable="item.choose"
          @click="clkName(index)"
          @close="closeName(index)"
          type="info"
        >{{item.subject}}</el-tag>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleAut = false">跳过</el-button>
        <el-button
          @click="determine"
          type="primary"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRes, tempclaimdatastore, finish, BatchInsert } from '@/api/claim'
import collapse from './collapse'
import md5 from 'js-md5'
export default {
  name: 'research',
  data () {
    return {
      nameOrgArrays: JSON.parse(localStorage.getItem('nameOrgArrays')), // 专家信息
      resourcetoken: '', // 完成时候需要的参数
      tableData: [], // 成果列表
      /* 百叶窗 */
      type: 0,
      collapseList: [
        { title: '我的论文', code: 'J', data: [] },
        { title: 'SCI收录', code: 'I', data: [] },
        { title: 'EI收录', code: 'E', data: [] },
        { title: '我的专利', code: 'P', data: [] },
        { title: '我的项目', code: 'O', data: [] },
        { title: '我的图书', code: 'B', data: [] },
        { title: '成果奖励', code: 'A', data: [] },
        { title: '会议论文', code: 'C', data: [] },
        { title: '学位论文', code: 'D', data: [] }
      ],
      /* loading */
      loading: false,
      loading1: false,
      /* 弹窗 */
      dialogFormVisibleAut: false,
      subjectList: [] // 可选择学科
    }
  },
  components: {
    collapse
  },
  methods: {
    changeType (data) {},
    // 获取数据
    getData () {
      this.loading = true
      this.collapseList.forEach((item, index) => {
        let temp = [item.code]
        let data = {
          from: 0,
          isClaimed: 0,
          nameOrgArray: this.nameOrgArrays,
          resource: temp,
          size: 500,
          subject: ''
        }
        // 获取每个类型的成果数据
        getRes(data)
          .then(res => {
            if (index === 8) {
              this.loading = false
            }
            this.collapseList[index].data = res.obj.result
            if (item.code === 'J') {
              if (Object.keys(res.obj.stats1.subject).length) {
                this.subjectList = res.obj.stats1.subject[0].subjects
              }
              if (this.subjectList.length > 5) {
                this.dialogFormVisibleAut = true
              }
            }
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 根据学科获取论文
    getScreen (subject) {
      this.loading = true
      let data = {
        from: 0,
        isClaimed: 0,
        nameOrgArray: this.nameOrgArrays,
        resource: ['J'],
        size: 500,
        subject: Object.keys(subject).length ? subject : ''
      }
      getRes(data)
        .then(res => {
          this.loading = false
          this.collapseList[0].data = res.obj.result
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 保存
    async saveData (data) {
      // this.loading = true
      let ExpertResources = []
      data.tableData.forEach((item, index) => {
        let expList = item
        expList.KId = this.$route.query.Kid
        expList.AutoDelete = null
        expList.UnionId = item.resourceId ? item.resourceId : ''
        expList.ResourceId = item.resourceId ? item.resourceId : ''
        expList.CandidateId = item.candidateResources
          ? item.candidateResources.split(item.name)[0].split('<ID>')[0]
          : ' '
        expList.IsConfirmed = true
        expList.IsSystem = item.isSystem ? item.isSystem : ''
        let str = JSON.stringify(expList)
        switch (data.code) {
          case 'J':
            expList.Paper = JSON.parse(str)
            break
          case 'I':
            expList.SCI = JSON.parse(str)
            break
          case 'E':
            expList.EI = JSON.parse(str)
            break
          case 'P':
            expList.Patent = JSON.parse(str)
            break
          case 'O':
            expList.Project = JSON.parse(str)
            break
          case 'B':
            expList.Book = JSON.parse(str)
            break
          case 'A':
            expList.Reward = JSON.parse(str)
            break
          case 'C':
            expList.Conference = JSON.parse(str)
            break
          case 'D':
            expList.DegreeObj = JSON.parse(str)
            break
          default:
            break
        }
        ExpertResources.push(expList)
      })
      let temp = {
        ExpertKId: this.$route.query.Kid,
        ExpertResources: ExpertResources,
        OperateEmployeeId: 0,
        OperateUserId: JSON.parse(localStorage.getItem('user')).Id,
        ResourceCode: data.code,
        resourcetoken: this.resourcetoken
      }
      // 保存成果
      tempclaimdatastore(temp)
        .then(res => {
          this.loading = false
          this.$message({
            message: '保存成功',
            offset: '200'
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 完成成果认领
    finish () {
      this.loading = true
      let data = {
        ResourceCode: '',
        resourcetoken: this.resourcetoken
      }
      finish(data).then(res => {
        if (res.dataflag === 0) {
          this.loading = false
          this.$message({
            message: '认领完成认领完成，专家数据正在同步',
            offset: '200'
          })
          this.$router.push({
            path: '/claim/manage',
            query: {kid: this.$route.query.Kid}
          })
          return
        }
        let isCode = true
        res.data.forEach((item, index) => {
          if (res.data[index].code === 'D') {
            isCode = false
          }
        })
        if (isCode) {
          res.data.push({
            code: 'D',
            ExpertResources: []
          })
        }
        res.data.forEach((item, index) => {
          this.submit(item)
        })
      }).catch(err => {
        console.log(err)
      })
    },
    // 完成成果认领
    submit (item) {
      let Kid = this.$route.query.Kid
      let data = {
        OperateUserId: JSON.parse(localStorage.getItem('user')).Id,
        OperateEmployeeId: 0,
        ExpertResources: item.ExpertResources,
        ExpertKId: Kid,
        ResourceCode: item.code,
        step: 10
      }
      BatchInsert(data).then(res => {
        this.loading = false
        if (res.status === 1) {
          this.$message({
            message: '认领完成认领完成，专家数据正在同步',
            offset: '200'
          })
        } else {
          this.$message({
            message: res.msg,
            offset: '200'
          })
        }
        this.$router.push({
          path: '/claim/manage',
          query: {kid: Kid}
        })
      }).catch(err => {
        console.log(err)
      })
    },
    // 选中学科
    clkName (index) {
      this.loading1 = true
      if (this.subjectList[index].choose === true) {
        return
      }
      this.subjectList[index].choose = true
      this.loading1 = false
    },
    // 取消选中学科
    closeName (index) {
      this.loading1 = true
      this.subjectList[index].choose = false
      this.loading1 = false
    },
    // 关闭弹窗并且根据选中学科获取数据
    determine () {
      let temp = []
      this.subjectList.forEach((item, index) => {
        if (item.choose) {
          temp.push(item.subject)
        }
      })
      if (temp.length > 0) {
        this.getScreen(temp)
      }
      this.dialogFormVisibleAut = false
    }
  },
  mounted () {
    if (!localStorage.getItem('user')) {
      this.$router.push({
        path: '/'
      })
    }
    this.getData()
    this.resourcetoken = md5(JSON.parse(localStorage.getItem('user')).tid + Math.ceil(Math.random() * 10) + Math.ceil(Math.random() * 10))
  }
}
</script>

<style lang="scss">
.research {
  padding-top: 50px;
  .title {
    color: #bfbfbf;
    background: #fff;
    text-align: center;
    padding-top: 50px;
  }
  .folding {
    background: #fff;
    padding: 0 20px;
    padding-top: 20px;
    text-align: center;
    .finish{
        width: 9rem;
      margin: 30px 0;
    }
  }
}
.dialog{
  .el-dialog{
    .el-dialog__body{
      .dialog_autView{
        .autInfo{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
          }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/claim/claimResearch.vue